import styled from "@emotion/styled";
import { mdsColorsValue } from "@/design-system/foundations";

export interface FadeBottomProps {
  $surfaceKind?: keyof (typeof mdsColorsValue)["surface"];
}

export const FadeBottom = styled.div<FadeBottomProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 28px;
  width: 100%;
  background: linear-gradient(
    180deg,
    ${({ $surfaceKind = "pane", theme }) => theme.colors.surface[$surfaceKind]}00 0%,
    ${({ $surfaceKind = "pane", theme }) => theme.colors.surface[$surfaceKind]}DA 85.42%,
    ${({ $surfaceKind = "pane", theme }) => theme.colors.surface[$surfaceKind]} 100%
  );
`;
